module.exports = __webpack_public_path__ + "static/img/police_badge.d0289dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/police_badge.jpg
// module id = h/JQ
// module chunks = 1